import React from "react";
import {
  CommercialPage,
  PageIntro,
  ContactCTA,
  ProcessSteps,
} from "../components/commercial";
import { commercialMetadata } from "./commercial-metadata";
export default function Partners() {
  return (
    <CommercialPage meta={commercialMetadata.partners}>
      <PageIntro
        label="Referral Partner Program"
        title="Bring the opportunity. We handle the engineering."
      >
        Connect Quantingo with a company facing a relevant software or systems
        challenge. You do not need to estimate, scope or deliver the engineering
        work.
      </PageIntro>
      <section className="section services-section">
        <div className="container about-grid">
          <div>
            <p className="eyebrow">The standard commission</p>
            <h2>5%, 10% or 15%, based on project value.</h2>
            <p className="page-copy">
              Your rate is determined by the total contracted project value. It
              applies to eligible revenue attributable to the first six months
              of implementation, starting on the effective execution start date.
              This is the Commission Window.
            </p>
            <p className="page-copy">
              The full project value determines the rate; the portion within the
              window determines the commission base. Advance payment does not
              expand that base.
            </p>
          </div>
          <div className="work-card page-prose">
            <h3>Small projects — 5%</h3>
            <p>Total contracted value under US$60,000.</p>
            <h3>Medium projects — 10%</h3>
            <p>US$60,000 to under US$500,000.</p>
            <h3>Large projects — 15%</h3>
            <p>US$500,000 or more.</p>
            <p>
              For example, a US$600,000 project with US$350,000 in eligible
              packages within its first six months has US$52,500 potential
              commission at 15%.
            </p>
            <h3>Paid on revenue received and retained.</h3>
            <p>
              Commission becomes payable after Quantingo receives the
              corresponding client revenue and the 30-day Commission Clearance
              Period has passed. Refunds or payment reversals
              reduce the commissionable amount.
              Each payment includes a Commission Statement for transparency.
            </p>
          </div>
        </div>
      </section>
      <section className="section container about-grid">
        <div>
          <p className="eyebrow">Who it is for</p>
          <h2>Relationships that reveal real engineering needs.</h2>
          <p className="page-copy">
            Consultants, technical professionals, fractional executives,
            agencies, IT and hardware providers, system integrators and industry
            specialists can identify opportunities through their networks.
          </p>
          <a className="text-link" href="/services">
            Explore the problems we solve <span aria-hidden="true">↗</span>
          </a>
        </div>
        <ProcessSteps
          steps={[
            [
              "Identify and introduce",
              "Connect us with a relevant decision maker or technical contact facing a concrete engineering need. A company name alone is not a referral.",
            ],
            [
              "Confirm the opportunity",
              "Quantingo confirms attribution before substantial commercial work whenever reasonably possible, then handles qualification, paid Assessment, proposal, scope and delivery.",
            ],
            [
              "Earn on eligible payments",
              "Commission becomes payable on revenue attributable to the first six months of implementation, once received and retained after 30-day clearance.",
            ],
          ]}
        />
      </section>
      <section className="section services-section">
        <div className="container about-grid">
          <div>
            <p className="eyebrow">Clear boundaries</p>
            <h2>Partner → Opportunity → Project</h2>
            <p className="page-copy">
              Referral attribution does not create permanent ownership of a
              client relationship.
            </p>
          </div>
          <div className="page-prose">
            <h3>What is eligible?</h3>
            <p>
              Paid Engineering Assessment is a separate project, is not
              commissionable, and consumes none of the implementation Commission
              Window. Unless specifically agreed otherwise, recurring revenue,
              hosting, managed services, maintenance subscriptions, recurring
              support, reimbursed expenses, client hardware, third-party
              licenses and other direct pass-through expenses are excluded.
            </p>
            <p>
              Banking, payment-processing, transfer and foreign-exchange costs
              incurred by Quantingo do not reduce the eligible commission base.
            </p>
            <h3>What about future work?</h3>
            <p>
              Follow-on work does not automatically qualify. If you later
              materially originate or develop a new opportunity with the same
              client and Quantingo accepts its attribution, that project may
              independently qualify with its own classification, rate, six-month
              window and clearance period for each receipt.
            </p>
            <h3>An independent relationship</h3>
            <p>
              The standard program is non-exclusive. Partners introduce
              opportunities and should not make commitments about Quantingo’s
              price, scope, architecture or delivery schedule. Broader sales
              roles can be agreed separately. Opportunity-specific commission
              exceptions must be explicitly agreed and documented before
              attribution or engagement.
            </p>
          </div>
        </div>
      </section>
      <ContactCTA
        title="Start a partner conversation."
        label="Discuss a referral partnership"
        href="/contact#partners"
      >
        Tell us about your background, network and the kinds of engineering
        opportunities you encounter. You can start without disclosing sensitive
        client information.
      </ContactCTA>
    </CommercialPage>
  );
}
